export const cookies = {
label: 'LEGAL',
title: 'Política de Cookies',
last_updated: 'Última Actualización: Enero 2024',
intro: 'Esta Política de Cookies explica cómo One More Global Inc. utiliza cookies y tecnologías similares en nuestro sitio web.',
what_title: 'Qué son las Cookies',
what_text: 'Las cookies son pequeños archivos de datos que se colocan en su dispositivo cuando visita un sitio web. Se utilizan ampliamente para hacer que los sitios web funcionen de manera más eficiente y para proporcionar información de informes.',
types_title: 'Tipos de Cookies que Usamos',
essential: 'Cookies Esenciales',
essential_text: 'Requeridas para el funcionamiento de nuestro sitio web. Permiten funciones básicas como la navegación de páginas y el almacenamiento de preferencias de idioma.',
analytics: 'Cookies de Análisis',
analytics_text: 'Nos ayudan a comprender cómo los visitantes interactúan con nuestro sitio web recopilando e informando información de forma anónima.',
manage_title: 'Gestión de Cookies',
manage_text: 'Puede configurar su navegador para rechazar cookies o alertarlo cuando se envían cookies. Sin embargo, es posible que algunas partes de nuestro sitio web no funcionen correctamente sin cookies.',
contact_title: 'Contáctenos',
contact_text: 'Si tiene preguntas sobre nuestro uso de cookies, comuníquese con nosotros en nuestra oficina corporativa.',
};
